import { Component, Input } from '@angular/core';

@Component({
  selector: 'igo-collapsible',
  template: require('./collapsible.component.html'),
  styles: [require('./collapsible.component.styl')]
})
export class CollapsibleComponent {

  @Input()
  get title() { return this._title; }
  set title(value: string) {
    this._title = value;
  }
  private _title: string = '';

  @Input()
  get collapsed() { return this._collapsed; }
  set collapsed(value: boolean) {
    this._collapsed = value;
  }
  private _collapsed: boolean = false;

  constructor() { }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/shared/collapsible/collapsible.component.ts